<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")
      EditIncome(v-if="income" :step.sync="step" :open.sync="showModal" @edit="editIncome" :loading="isLoading" :parentIncome.sync="income")
      RecordIncome(v-else :step.sync="step" :open.sync="showModal" @add="addIncome" :loading="isLoading")
     
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import RecordIncome from './RecordIncome.vue'
import EditIncome from './EditIncome.vue'

export default {
  name: 'AddIncomeDialog',
  components: { RecordIncome, EditIncome },
  props: ['open', 'parentIncome'],
  data: () => ({
    step: 0,
    isLoading: false,
    data: {
      income: null,
      payment: null,
      invoice: null
    }
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    income: {
      get() {
        return this.parentIncome
      },
      set(newValue) {
        this.$emit('update:parentIncome', newValue)
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    addIncome (val) {
      this.data = val
      this.postIncome()
    },
    editIncome (val) {
      this.data = val
      this.patchIncome()
    },
    postIncome () {
      this.isLoading = true
      this.$axios.post(`/books/${this.company.slug}/incomes/`, this.data.income)
        .then(resp => {
          const incomePid = resp.data.pid
          this.$axios.get(`/books/${this.company.slug}/incomes/${incomePid}/?expand=category,products`)
            .then(resp => {
              const income = resp.data
              this.$axios.patch(`/invoices/${income.pid}/`, this.data.invoice)
                .catch(() => {})
                .finally(() => {
                  if (this.data.payment && this.data.payment.payment_method) {
                    let paymentPath = 'add_partial_payment'
                    if (!this.data.payment.amount) {
                      paymentPath = 'add_full_payment'
                      income.payment_status = 'paid'
                    }
                    this.$axios.post(`/books/${this.company.slug}/incomes/${income.pid}/${paymentPath}/`, this.data.payment)
                      .then(() => {
                        this.showMessage(['success', this.$t('success_message.income_recorded_successfully')])
                        this.$axios.get(`/books/${this.company.slug}/incomes/${incomePid}/?expand=category,products`)
                          .then(resp => {
                            const income = resp.data
                            this.$emit('added', income)
                            this.showModal = false
                            this.isLoading = false
                          })
                      })
                      .catch(() => {
                        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
                        this.isLoading = false
                      })
                  } else {
                    this.$emit('added', income)
                    this.showModal = false
                    this.isLoading = false
                  }
                })
            })
            .catch(() => {})
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          this.isLoading = false
        })
    },
    patchIncome () {
      this.isLoading = true
      this.$axios.patch(`/books/${this.company.slug}/incomes/${this.income.pid}/`, this.data.income)
        .then(() => {
          this.$axios.patch(`/invoices/${this.income.pid}/`, this.data.invoice)
            .catch(() => {})
            .finally(() => {
              this.$axios.get(`/books/${this.company.slug}/incomes/${this.income.pid}/?expand=category,products`)
                .then(resp => {
                  this.income = resp.data
                  this.showMessage(['success', this.$t('success_message.income_edited')])
                  this.showModal = false
                  this.isLoading = false
                })
                .catch(() => {})
            })
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "cancel": "Cancel",
    "proceed": "Proceed"
  }
}
</i18n>
